<template>
  <div>
    <button class="btn mb-3 btn-success btn-sm" @click="$emit('change-section')">
      ← Torna al menu principale
    </button>

    <NavigationTabs
      v-model="activeTabId"
      :tabs="navigationTabs"
      @tab-click="handleTabClick"
    />

    <hr>

    <GestioneDisponibilita v-if="showDispSection" :currentUser="currentUser" />
    <SubjectAvailability v-if="showSubjSection" :currentUser="currentUser" />
    <div v-if="showPrenSection" class="mb-3">
      <ListaPrenotazioni :currentUser="currentUser" user-type="tutor" />
    </div>
    <ListaInterazioni v-if="showInterazioniSection" :current-user="currentUser" />
    <UserProfile
      v-if="showProfileSection"
      :userId="currentUser.id"
      :is-own-profile="true"
      :student="false"
    />
  </div>
</template>

<script>
import GestioneDisponibilita from "@/components/GestioneDisponibilita.vue";
import ListaPrenotazioni from "@/components/ListaPrenotazioni.vue";
import SubjectAvailability from "@/components/SubjectAvailability.vue";
import NavigationTabs from '@/components/NavigationTabs.vue';
import ListaInterazioni from "@/components/ListaInterazioni.vue";
import UserProfile from "@/components/UserProfile.vue";

export default {
  name: 'TutorDashboard',
  components: {
    UserProfile,
    GestioneDisponibilita,
    SubjectAvailability,
    ListaPrenotazioni,
    NavigationTabs,
    ListaInterazioni
  },
  props: {
    currentUser: {
      type: Object,
      required: true
    },
    activeTab: {
      type: [String, Array],
      required: true
    }
  },
  data() {
    return {
      activeTabId: Array.isArray(this.activeTab) ? this.activeTab[0] : this.activeTab
    };
  },
  computed: {
    navigationTabs() {
      const allTabs = [
        { id: 'sezione-disponibilita', label: 'Disponibilità temporali', event: 'show-disponibilita' },
        { id: 'sezione-subject-availability', label: 'Materie insegnabili', event: 'show-subject-availability' },
        { id: 'sezione-prenotazioni', label: 'Prenotazioni', event: 'show-prenotazioni' },
        { id: 'sezione-interazioni', label: 'Interazioni', event: 'show-interazioni' },
        { id: 'sezione-profilo', label: 'Profilo', event: 'show-profile' }
      ];

      const allowedTabs = Array.isArray(this.activeTab) ? this.activeTab : [this.activeTab];
      return allTabs.filter(tab => allowedTabs.includes(tab.id));
    },
    showDispSection() {
      return this.activeTabId === 'sezione-disponibilita';
    },
    showSubjSection() {
      return this.activeTabId === 'sezione-subject-availability';
    },
    showPrenSection() {
      return this.activeTabId === 'sezione-prenotazioni';
    },
    showInterazioniSection() {
      return this.activeTabId === 'sezione-interazioni';
    },
    showProfileSection() {
      return this.activeTabId === 'sezione-profilo';
    }
  },
  methods: {
    handleTabClick(tab) {
      this.$emit(tab.event);

      this.emitSectionChange({
        disp: tab.id === 'sezione-disponibilita',
        subj: tab.id === 'sezione-subject-availability',
        pren: tab.id === 'sezione-prenotazioni',
        interazioni: tab.id === 'sezione-interazioni',
        profile: tab.id === 'sezione-profilo'
      });
    },
    emitSectionChange({ disp, subj, pren, interazioni, profile }) {
      this.$emit('update:showDispSection', disp);
      this.$emit('update:showSubjSection', subj);
      this.$emit('update:showPrenSection', pren);
      this.$emit('update:showInterazioniSection', interazioni);
      this.$emit('update:showProfileSection', profile);
    }
  }
};
</script>
